import { render, staticRenderFns } from "./UtenteFattorino.vue?vue&type=template&id=20895197&"
import script from "./UtenteFattorino.vue?vue&type=script&lang=ts&"
export * from "./UtenteFattorino.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports